


















import { Component, Prop, Vue } from 'vue-property-decorator';
import TheHeartIcon from '@/components/icons/TheHeartIcon.vue';
import { sendGaEvent } from '@/helpers/ga/gaSend';
import CtaClickedGaEvent from '@/helpers/ga/events/CtaClickedGaEvent';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';

@Component({
  components: { TheHeartIcon },
})
export default class AddToFavoriteAction extends Vue {
  @Prop() event!: any;
  @Prop({ default: false, type: Boolean }) isFavorite: boolean;

  get name() {
    return this.isFavorite ? 'In My Favourites' : 'Add to Favourites';
  }

  handleClick() {
    this.$emit('click');

    const gaEvent = new CtaClickedGaEvent(this.name)
      .addContentType(getContentTypeFromEntityType(this.event.__typename))
      .addContentId(this.event.id)
      .addContentName(this.event.title);

    sendGaEvent(gaEvent);
  }
}
